import { Stream } from '@cloudflare/stream-react';
import { Dialog, DialogContent } from '@mui/material';
import { CSSProperties, ReactElement, SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as DeleteIcon } from 'assets/icons/newTrash.svg';
import { ReactComponent as PlayIcon } from 'assets/icons/play.svg';

import { MoreImages } from '../ListItemVideoAttachment/styled';
import { PlayButtonContainer, RemoveCircle, StyledImage, Thumb, VideoW } from './styled';

interface VideoAttachmentProps {
  postId?: string;
  attachmentId: string;
  file?: File;
  handleDelete?: () => void;
  onOpenGallery?: () => void;
  wrapperSx?: CSSProperties;
  moreVideos?: number | null;
  blockDelete?: boolean;
}

export function VideoAttachment({
  attachmentId,
  handleDelete,
  onOpenGallery,
  wrapperSx,
  moreVideos,
  blockDelete,
}: VideoAttachmentProps): ReactElement {
  const { t } = useTranslation();
  const [previewOpen, setPreviewOpen] = useState(false);
  console.log(blockDelete, 'blockDelete');
  const handleAttachmentRemove = (e: SyntheticEvent) => {
    e.stopPropagation();
    if (onOpenGallery) {
      onOpenGallery?.();
    } else {
      handleDelete?.();
    }
  };

  const handleThumbClick = () => {
    if (onOpenGallery) {
      onOpenGallery();
    } else {
      setPreviewOpen(true);
    }
  };

  const videoThumbnailurl = attachmentId
    ? `https://customer-${process.env.REACT_APP_CLOUDFLARE_STREAM_ACCOUNT_ID}.cloudflarestream.com/${attachmentId}/thumbnails/thumbnail.gif?time=1s&height=200&duration=4s`
    : '';

  const hasMoreVideos = Boolean(moreVideos);

  return (
    <>
      <Thumb style={wrapperSx} onClick={handleThumbClick}>
        <VideoW>
          <StyledImage src={videoThumbnailurl} />
          {hasMoreVideos && (
            <MoreImages>{t('common.moreImages', { count: moreVideos as number })}</MoreImages>
          )}
        </VideoW>
        <PlayButtonContainer>
          <PlayIcon />
        </PlayButtonContainer>

        {!blockDelete && (
          <RemoveCircle className="remove-btn" onClick={handleAttachmentRemove}>
            <DeleteIcon />
          </RemoveCircle>
        )}
      </Thumb>

      <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)}>
        <DialogContent sx={{ p: 1, minWidth: 480 }} onClick={(e) => e.stopPropagation()}>
          <Stream
            controls
            autoplay
            src={attachmentId}
            poster={`https://customer-${process.env.REACT_APP_CLOUDFLARE_STREAM_ACCOUNT_ID}.cloudflarestream.com/${attachmentId}/thumbnails/thumbnail.jpg`}
            height="270px"
            width="100%"
            responsive={false}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
